export default __webpack_public_path__ + "static/media/480_business06-en-mobile.6cd110f3.png";